// §34.9 / §9.1 — Voice Memos' registration stub.
//
// **Manifest and thunk only** (D-511), exactly as Archive's is: a plain `import` of the view would
// put the recorder, the store and the CSS in the entry chunk and nothing would look different. The
// chunk this thunk produces is `lazy.Voice-<hash>.js`, excluded from the service-worker precache by
// the same exact-prefix rule as `game.` (§34.16, D-199).
import type { InProcessApp, VoiceShellAccess } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';
import { COPY } from '@/copy';
import { VOICE_WINDOW } from '@/config';

export function createVoiceApp(access: VoiceShellAccess): InProcessApp {
  return createLazyApp({
    app: {
      id: 'voice',
      name: COPY.voice.title,
      // §34.1 (D-497) — the wave's launcher home.
      category: 'Utilities',
      // Hue from §14's ladder: a warm red, the colour a record button has always been.
      icon: { glyph: 'mic', hue: 4 },
      keywords: ['record', 'audio', 'memo', 'dictate', 'microphone', 'voice'],
      // No `fileTypes`: §34.9 gives Voice a folder, not a claim on `.webm` — Media (M60) is the
      // registered viewer for audio, and two default openers for one extension is a coin toss.
      window: { ...VOICE_WINDOW, multiWindow: false },
    },
    load: () => import('./Voice'),
    props: { access },
  });
}
